import { APPROVAL } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: APPROVAL,
  params: {},
  okAction: 'update',
  needFetchFillInfo: false,
  view: {
    content: [
      {
        $id: 'approvalStatus',
        $type: 'radio-group',
        label: '审批状态',
        $options: [
          {
            label: '同意',
            value: 'APPROVED'
          },
          {
            label: '拒绝',
            value: 'REJECTED'
          }
        ],
        $default: 'REJECTED',
        rules: [
          {
            notEmpty: '审批状态'
          }
        ]
      },
      {
        $id: 'comment',
        $type: 'input',
        label: '审批意见',
        $el: {
          placeholder: '请输入审批意见',
          type: 'textarea',
          rows: 5
        },
        $enableWhen: {
          approvalStatus: function(currentValue, data, meta) {
            // 如果有值设置
            if (currentValue != 'REJECTED') {
              return true
            }
          }
        }
      },
      {
        $id: 'comment',
        $type: 'input',
        label: '审批意见',
        $el: {
          placeholder: '请输入审批意见',
          type: 'textarea',
          rows: 5
        },
        rules: [
          {
            notEmpty: '审批意见'
          }
        ],
        $enableWhen: {
          approvalStatus: function(currentValue, data, meta) {
            // 如果有值设置
            if (currentValue != 'APPROVED') {
              return true
            }
          }
        }
      }
    ]
  }
}
